import React from 'react';
import Connected from '../../Components/Connected/Main/Main';

export default (): React.ReactElement => (
  <>
    <Connected />
  </>
);
